/**
=========================================================
Archivo para el login con Google
=========================================================
*
* La configuración se debe realizar en https://console.cloud.google.com/
*/

import React, { useState, useEffect } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useMaterialUIController } from "../../../context/index";

const GoogleAuth = () => {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Si el usuario ya tiene un token válido, lo redirigimos
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/Bienvenida");
    }
  }, []);

  // Mostrar alerta
  const handleAlertClick = (message) => {
    setMessage(message);
    setShowAlert(true);
  };

  // Cerrar alerta
  const handleDialogClose = () => {
    setShowAlert(false);
  };

  // Manejo del éxito en Google Login
  const handleSuccess = async (credentialResponse) => {
    const idToken = credentialResponse.credential;

    if (!idToken) {
      console.error("Error: No se recibió el ID Token de Google.");
      handleAlertClick("Error en la autenticación con Google.");
      return;
    }

    try {
      // Enviar el `id_token` al backend para validación y generación del JWT
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id_token: idToken }),
      });

      const dataResponse = await response.json();

      //debugger;
      if (response.ok && dataResponse.payload.token) {
        // Guardar el token JWT y datos del usuario en localStorage
        localStorage.setItem("token", dataResponse.payload.token);
        localStorage.setItem("roleId", dataResponse.payload.roleId);
        localStorage.setItem("permissions", JSON.stringify(dataResponse.payload.permissions));
        localStorage.setItem("user_id", dataResponse.payload.user.id);

        // Actualizar el estado global si es necesario
        dispatch({ type: "UPDATE_USER_ID", payload: dataResponse.payload.user.id });

        // Redirigir al usuario a la página de bienvenida
        navigate("/Bienvenida");
      } else {
        handleAlertClick(dataResponse.error || "No estás autorizado para ingresar.");
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      handleAlertClick("Error en la conexión con el servidor.");
    }
  };

  return (
    <div>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => handleAlertClick("Error en la autenticación con Google.")}
      />

      {/* Diálogo de alerta */}
      <Dialog open={showAlert} onClose={handleDialogClose}>
        <DialogTitle
          style={{
            textAlign: "center",
            fontSize: "1.5rem",
            backgroundColor: "#007BFF",
            color: "#FFF",
          }}
        >
          {"¡¡No estás autorizado para ingresar!!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            style={{
              textAlign: "center",
              fontSize: "1.2rem",
              marginTop: "8px",
              backgroundColor: "#FFF",
              color: "#000",
            }}
          >
            {message || "Verifica tu dirección de correo electrónico."}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            onClick={handleDialogClose}
            color="primary"
            style={{ backgroundColor: "#007BFF", color: "#FFF" }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GoogleAuth;
